export enum POIFilterType {
    Wall = 'Wall',
    Corner = 'Corner'
}